export default __webpack_public_path__ + "static/media/img-0333-botswana-half-face.07c27237.png";